<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="6">
                <el-text-field
                  label="Paslaugos pavadinimas (LT)"
                  v-model="mainData['title_lt-search-custom']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Paslaugos pavadinimas (EN)"
                  v-model="mainData['title_en-search-like']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Paslaugos kodas"
                  v-model="mainData['code-search-like']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="PASIS kodas"
                  v-model="mainData['pasis_code-search-like']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
               <v-col cols="12" md="6">
                <el-text-field
                  label="Institucijos kodas"
                  v-model="mainData['institution_code-search-custom']"
                  hide-details
                  :maxlength="20"
                />
              </v-col>
               <v-col cols="12" md="6">
                <el-text-field
                  label="Institucijos pavadinimas"
                  v-model="mainData['institution_fullname-search-custom']"
                  hide-details
                  :maxlength="200"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="12" lg="6">
                <el-autocomplete
                  :items="enumsClassifiers.sector"
                  enums
                  itemvalue="value"
                  itemtext="text"
                  label="Paslaugos teikėjas"
                  hide-details
                  v-model="mainData['sector-search-like']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="4" lg="2">
                <el-date-picker
                  label="Galioja nuo"
                  v-model="mainData['valid_from-search-from']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="4" lg="2">
                <el-date-picker
                  label="Galioja iki"
                  v-model="mainData['valid_to-search-to']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="4" lg="2">
                 <el-autocomplete
                  :items="enumsClassifiers.activeSelect"
                  enums
                  itemvalue="value"
                  itemtext="text"
                  label="Aktyvumas"
                  v-model="mainData['is_active-search-custom']"
                />
              </v-col>
              <v-col class="pt-0" cols="12" md="6">
                <el-text-field
                  label="IS identifikatorius"
                  v-model="mainData['is_identificator-search-like']"
                  hide-details
                  :maxlength="200"
                />
              </v-col>
              <v-col class="pt-0" cols="12" md="4" lg="2">
                <el-autocomplete
                  :items="enumsClassifiers.signatureRequired"
                  enums
                  itemvalue="value"
                  itemtext="text"
                  label="Reikalingas el. parašas"
                  v-model="mainData['signature_required-search-custom']"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-report-btn @downloadReport="downloadReport" object="actions" :loading="loading" :reportData="reportData"  />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Enums from '@/enums'

export default {
  name: 'AdminServicesSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    reportData: {},
    enumsClassifiers: [],
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getClassifiers()
    this.searchData()
  },
  methods: {
    downloadReport() {
      this.$emit('downloadReport')
    },
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getClassifiers() {
      this.enumsClassifiers = Enums
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData(button) {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      searchData.btn = button
      this.reportData = { ...this.mainData }
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {isExpanded: true, clear: true }
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData(true)
      })
    },
    submit() {
      this.beforeSearch()
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
            this.searchData(true)
        }
      })
    },
  },
}
</script>
